import React, { useState, useEffect } from 'react';
import rotatingIconSvg from '../../assets/imgs/1.svg';
import './OrganizationBanner.css';

const OrganizationBanner = () => {
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'KU';
  });

  // Listen for language changes
  useEffect(() => {
    // Get initial language from localStorage or default to KU
    const savedLang = localStorage.getItem('selectedLanguage') || 'KU';
    setCurrentLang(savedLang);

    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
      localStorage.setItem('selectedLanguage', event.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const organizationTexts = {
    EN: 'Reboon Organization for Education and Training',
    KU: 'ڕێكخراوی ڕێبوون بۆ په‌روه‌رده‌ و ڕاهێنان',
    AR: 'منظمة ریبوون للتعليم والتدريب',
    TR: 'Reboon Eğitim ve Öğretim Örgütü'
  };

  const organizationDescriptions = {
    EN: 'It is an independent non-profit rehabilitation guidance institution',
    KU: 'دامەزراوەیەکی ڕێنمونیکاری چاکسازی سەربەخۆی قازانج نەویستە',
    AR: 'هي مؤسسة مستقلة غير ربحية تُعنى بتقديم الإرشاد في مجال إعادة التأهيل',
    TR: 'Bağımsız, kar amacı gütmeyen bir rehabilitasyon rehberlik kurumudur.'
  };

  return (
    <div className="organization-banner">
      <div className="organization-banner-content">
        <div className="rotating-icon-wrapper">
          <img src={rotatingIconSvg} alt="Organization Icon" className="rotating-icon" />
        </div>
        <div className="organization-text-wrapper">
          <h2 className="organization-text">
            {organizationTexts[currentLang] || organizationTexts.EN}
          </h2>
          <p className="organization-description">
            {organizationDescriptions[currentLang] || organizationDescriptions.EN}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrganizationBanner;

